import styled from 'styled-components';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  .loading-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }

  @media (max-width: ${BP_TABLET_MAX}px) {
    max-width: 560px;
    margin: 0 auto;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
    margin: 0 auto;
  }
`;

export const TopContentWrapSC = styled.div`
  padding-bottom: 16px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const TableContentWrapSC = styled.div`
  width: 100%;
`;
